<h2 mat-dialog-title>{{ 'administration.sync-monitoring.report-dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.reset-dialog.environment' | translate }}:</span>
		<strong>{{ data.environmentName }}</strong>
	</p>
	<p class="audit-dialog-note">{{ 'administration.sync-monitoring.report-dialog.description' | translate }}</p>

	@if (state === 'building') {
		<p class="audit-dialog-note">
			<mat-progress-spinner diameter="18" mode="indeterminate" class="audit-dialog-spinner"></mat-progress-spinner>
			{{ 'administration.sync-monitoring.report-dialog.building' | translate }}
		</p>
	}
	@if (errorKey) {
		<p class="audit-dialog-warning">{{ 'administration.sync-monitoring.' + errorKey | translate }}</p>
	}
	@if (stats) {
		<p class="audit-dialog-note">{{ 'administration.sync-monitoring.report-dialog.stats' | translate: stats }}</p>
	}
	@if (preview) {
		<pre class="audit-dialog-json" tabindex="0" [attr.aria-label]="'administration.sync-monitoring.report-dialog.title' | translate">{{ preview }}</pre>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" mat-dialog-close>{{ 'administration.sync-monitoring.report-dialog.close' | translate }}</button>
	<button mat-stroked-button type="button" [disabled]="!reportText" (click)="copy()">{{ 'administration.sync-monitoring.report-dialog.copy' | translate }}</button>
	<button mat-flat-button color="primary" type="button" [disabled]="!url" (click)="save()">{{ 'administration.sync-monitoring.report-dialog.save' | translate }}</button>
</mat-dialog-actions>
